export default "__VITE_ASSET__badfbfb7__"